import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferBar() {
  const {
    formatted
  } = useCountdown(15 * 60); // 15 minutes
  return <div className="fixed top-0 left-0 w-full bg-gradient-to-r from-primary-dark to-primary text-white text-center p-2.5 font-bold text-sm z-[1000] shadow-[0_2px_5px_rgba(0,0,0,0.1)] border-b-2 border-primary-light flex justify-center items-center gap-1.5" data-id="element-166">
      <span className="text-[16px] mr-1" data-id="element-167">🥗</span>
      <span className="font-extrabold mr-1" data-id="element-168">Tus Recetas Saludables</span>
      <span className="mx-1 opacity-60" data-id="element-169">|</span>
      <FlameIcon size={14} className="text-accent" data-id="element-170" />
      <span data-id="element-171">Oferta termina en:</span>
      <span className="text-accent font-extrabold animate-pulse" data-id="element-172">
        {formatted}
      </span>
    </div>;
}